import i18n from 'answers-chrome-extension/src/i18n';

import { ITrackEventOrigin } from '../../../services/mixpanel/types';
import { getToastService, TOAST_BOTTOM_OFFSET } from '../../../services/toast/toast-service';
import { TEXT_HTML, TEXT_PLAIN } from '../../constants';

export const prepareClipboardItems = (url: string, title?: string): Record<string, Blob> => {
    // Generate the rich format
    const link = `<a href='${url}'>${title ?? url}</a>`;
    const htmlType = 'text/html';
    const html = new Blob([link], { type: htmlType });

    const plainType = 'text/plain';
    const text = new Blob([url], { type: plainType });

    return { [TEXT_HTML]: html, [TEXT_PLAIN]: text };
};

export const showSuccessToast = (origin?: string, publicSource?: boolean) => {
    const textKey = publicSource ? 'link.copy.public.success' : 'link.copy.private.success';

    getToastService().info(i18n.t(textKey), {
        ...(origin === ITrackEventOrigin.PREVIEW_WINDOW && { marginBottom: TOAST_BOTTOM_OFFSET }),
    });
};
